import _ from 'lodash';
import './js/flasher.js';